import {
  configureStore,
  ThunkAction,
  Action,
  combineReducers,
  AnyAction,
} from '@reduxjs/toolkit';
import * as poctoolsContentManagementState from './poctoolsContentManagement/poctoolsContentManagementReducer';
import * as POCToolsWebPortal from './POCToolsWebPortal/POCToolsWebPortalReducer';
import * as login from './login/loginReducer';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const persistConfigPOCTools = {
  key: 'JWT',
  storage: storage,
  whitelist: ['pointOfCareTool', 'displayPocToolContent'],
};

const persistConfigJWT = {
  key: 'JWT',
  storage: storage,
  whitelist: ['userId', 'token', 'refreshToken'],
};
import * as UserSettings from './userSettings/userSettingsReducer';

export interface ApplicationState {
  poctoolsContentManagementState: poctoolsContentManagementState.poctoolsContentManagementState;
  POCToolsWebPortal: POCToolsWebPortal.POCToolsWebPortalState;
  UserSettings: UserSettings.UserSettingsState;
}

const combinedReducer = combineReducers({
  poctoolsContentManagementState: persistReducer(
    persistConfigPOCTools,
    poctoolsContentManagementState.reducer,
  ),
  POCToolsWebPortal: POCToolsWebPortal.reducer,
  login: persistReducer(persistConfigJWT, login.reducer),
  UserSettings: UserSettings.reducer,
});

const rootReducer = (state: any, action: AnyAction) => {
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer: rootReducer,
});

export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
